import React from 'react';
import Iframe from 'react-iframe';

export default function PowerBi() {
    return (
        <section id='BI'>
            <div className='contain'>
                <Iframe
                    title='Dashboard de Contratos de obras'
                    width='1140'
                    height='541.25'
                    url='https://app.powerbi.com/reportEmbed?reportId=b854223b-4db2-47f8-b026-4c3a16077c9c&autoAuth=true&ctid=9dfb1a05-5f1d-449a-8960-62abcb479e7d'
                    frameBorder={0}
                    allowFullScreen></Iframe>
            </div>
        </section>
    );
}
